import SEO from "@/components/SEO";
import CTASection from "@/components/CTASection";
import { MaskedLines, FadeUp, SectionTag } from "@/components/Reveal";
import { SERVICES, IMAGES } from "@/data/content";

const Leistungen = () => (
  <div data-testid="leistungen-page">
    <SEO
      title="Leistungen – Beratung, individuelle Reden & Live-Musik | Daviz & Puxi"
      description="Alle Leistungen von Mark Daviz & Angela Puxi: Kennenlerngespräch, individuell geschriebene Reden, Live-Gesang & Saxophon, Durchführung und Moderation Ihrer Zeremonie."
      path="/leistungen"
    />

    <section className="mx-auto max-w-7xl px-5 pb-16 pt-36 sm:px-8 sm:pt-44">
      <FadeUp>
        <SectionTag>Leistungen</SectionTag>
      </FadeUp>
      <MaskedLines
        lines={["Alles, was Ihre", "Zeremonie braucht."]}
        className="mt-6 font-serif text-5xl leading-[1.05] sm:text-7xl"
        delay={0.15}
      />
      <FadeUp delay={0.5}>
        <p className="mt-8 max-w-2xl text-lg leading-relaxed text-stone">
          Bei uns gibt es keine Zeremonie von der Stange. Jede entsteht individuell – aus Ihren
          Geschichten, Ihren Wünschen und vielen persönlichen Gesprächen. Das ist alles Teil davon:
        </p>
      </FadeUp>
    </section>

    <section className="mx-auto max-w-7xl px-5 pb-24 sm:px-8">
      <div className="grid gap-x-12 md:grid-cols-2">
        {SERVICES.map((s, i) => (
          <FadeUp key={s.title} delay={(i % 2) * 0.08}>
            <div data-testid={`leistung-${i}`} className="group flex gap-6 border-b border-sand/70 py-8">
              <span className="font-accent text-3xl italic leading-none text-sand">{String(i + 1).padStart(2, "0")}</span>
              <div>
                <h2 className="font-serif text-2xl transition-colors duration-300 group-hover:text-rust">{s.title}</h2>
                <p className="mt-2.5 leading-relaxed text-stone">{s.text}</p>
              </div>
            </div>
          </FadeUp>
        ))}
      </div>
    </section>

    <section className="relative overflow-hidden py-24 sm:py-32">
      <img src={IMAGES.pathway} alt="Goldenes Feld im warmen Abendlicht" loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-mossdeep/85" />
      <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8">
        <FadeUp>
          <p className="font-accent text-3xl italic leading-snug text-creme sm:text-4xl">
            „Wir begleiten wenige Zeremonien – dafür jede ganz.
            Ihre Geschichte bekommt die Zeit, die sie verdient."
          </p>
          <p className="mt-8 text-xs font-semibold uppercase tracking-[0.3em] text-sand">Mark Daviz & Angela Puxi</p>
        </FadeUp>
      </div>
    </section>

    <CTASection
      title={["Klingt das nach", "dem, was Sie suchen?"]}
      text="Erzählen Sie uns von Ihrem Anlass – wir sagen Ihnen ehrlich, wie wir ihn gestalten würden. Unverbindlich und ohne Verpflichtung."
      buttonLabel="Zeremonie anfragen"
    />
  </div>
);

export default Leistungen;
